import { useHttpClient } from "@/common/api/httpClient";
import { storeToRefs } from "pinia";
import { useLanguageStore } from "shared/translations/stores/languageStore";
import type { StorageAreaResponse } from "./models/storageAreaResponse";

export interface UndoInventoryStorageAreaResponse {
  ok: true;
  storageArea: StorageAreaResponse;
}

export function useUndoInventoryApi() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  async function execute() {
    const headers = httpClient.defaultHeaders();

    const request = new Request(httpClient.siteUrl('inventory/undo'), {
      headers,
      method: 'POST'
    });

    const text = translations.value.storageAreas.actions.undoInventory;

    const response = await httpClient.action<UndoInventoryStorageAreaResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const json = await response.json() as StorageAreaResponse;

        return {
          ok: true,
          storageArea: json
        };
      },
    });

    return response;
  }

  return {
    execute
  };
}
